/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_centroid_agg.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Calculate the spatial centroid over a field with spatial geometry type.
 * Supports `geo_point` and `cartesian_point`, as well as `geo_shape` and `cartesian_shape`.
 *
 * @example
 * FROM airports
 * | STATS centroid=ST_CENTROID_AGG(location)
 */
const definition: FunctionDefinition = {
  type: 'agg',
  name: 'st_centroid_agg',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_point',
    },
    {
      params: [
        {
          name: 'field',
          type: 'cartesian_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_point',
      license: 'PLATINUM',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_point',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geo_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_point',
      license: 'PLATINUM',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
